import type { BuilderConfig } from '@/types/builder';
import HeadTags from './HeadTags.vue';

export default {
    component: HeadTags,
    description: 'Add tags to the head of the page',
    noWrap: true,
    inputs: [
        {
            name: 'tags',
            description: 'List of tags to add to the head of the page',
            required: true,
            type: 'list',
            defaultValue: [
                {
                    type: 'script',
                },
            ],
            subFields: [
                {
                    name: 'type',
                    description: 'Type of the HTML tag',
                    type: 'string',
                    required: true,
                    enum: [
                        'script',
                        'link',
                        'meta',
                        'style',
                    ],
                },
                {
                    name: 'attributes',
                    description: 'HTML attributes of the tag specified by name and value',
                    type: 'list',
                    defaultValue: [{}],
                    subFields: [
                        {
                            name: 'name',
                            required: true,
                            type: 'string',
                        },
                        {
                            name: 'value',
                            type: 'string',
                        },
                    ],
                },
                {
                    name: 'content',
                    type: 'longText',
                    description: 'HTML content of the tag',
                },
            ],
        },
    ],
    shouldReceiveBuilderProps: {
        builderLinkComponent: false,
    },
} satisfies BuilderConfig;
